/*
 * revalidate
 *
 * handles the revalidating of fields on input blur.
 * when a field is optional and is emptied,
 * the `valid` class is removed from the input
 *
 * Notes:
 * - here we use attr() instead of prop() for functionality in IE10
 *
 * GDL Requirements
 * - optional fields should not show as valid when empty
 *
 * Dependencies
 * - jQuery Validate https://jqueryvalidation.org/
 */

const revalidate = () => {
  $(() => {
    /* Set defaults of validator to ignore nothing, not even hidden inputs */
    $.validator.setDefaults({ ignore: [] });

    /* Re-validate when cleared: fight the lazy validation https://stackoverflow.com/questions/33133749/jquery-validation-doesnt-validate-when-input-is-removed/33134409#33134409 */
    /* Also: handle optional fields */
    $('input, textarea, select').on('blur', function handleInputBlur() {
      const input = $(this);

      /* If field is optional, meaning backend didn't put data-val-required on it based on the campaign-pages */
      if (input.attr('data-val-required') === undefined) {
        const name = input.attr('name');

        /* Per input type, if field is empty / unchecked / etc. */
        let isEmptied = false;
        switch (input.attr('type')) {
        case 'text':
        case 'number':
        case 'tel':
        default:
          isEmptied = (input.val() !== undefined && input.val() === '');
          break;
        case 'radio':
        case 'checkbox':
          isEmptied = ($(`[name='${name}']:checked`).length === 0);
          break;
        }
        if (isEmptied) {
          $(`input[name='${name}']`).removeClass('valid');
        } else {
          $(`input[name='${name}']`).valid();
        }
      } else {
        input.valid();
      }
    });
  });
};

export default revalidate;
